// Services
import { apiInstance, gql } from "@/services/httpAdapter";

// Helpers
import { errorLogger } from "@Common/helpers/logger";

// Types
import { GraphqlQueryResponse } from "@Common/api/types/GraphqlQueryResponse";
import { ITechnicianFlaggedTimeBase } from "@/DataPages/types/technicianFlaggedTime/model";

export async function updateTechnicianPerformance({
	locationId,
	payPeriodId,
	commissionCycleId,
	input,
}: {
	locationId: string;
	payPeriodId: string;
	commissionCycleId: string;
	input: { isFinalized: boolean };
}) {
	const query = gql`
		mutation updateTechnicianPerformance(
			$locationId: String!
			$payPeriodId: String!
			$commissionCycleId: String!
			$input: TechnicianPerformanceInput
		) {
			updateTechnicianPerformance(
				locationId: $locationId
				payPeriodId: $payPeriodId
				commissionCycleId: $commissionCycleId
				input: $input
			) {
				_id
				locationId
				commissionCycleId
				payPeriodId
				isFinalized
			}
		}
	`;

	const variables = {
		locationId,
		payPeriodId,
		commissionCycleId,
		input,
	};

	try {
		const response: GraphqlQueryResponse<"updateTechnicianPerformance", ITechnicianFlaggedTimeBase> = await apiInstance.post(
			"/graphql",
			{
				query,
				variables,
			}
		);
		return response.data.data?.updateTechnicianPerformance;
	} catch (err) {
		errorLogger(err as Error, {
			function: "updateTechnicianPerformance",
			message: "Failed to update technician performance",
			variables,
		});
		return null;
	}
}
